'use strict';
import actionTypes from './actionTypes';
if (typeof window !== 'undefined') {
    var $ = window.$;
}

function getUserDetails(callback) {
    return function(dispatch, getState) {
        $.ajax({
            url: '/sub-marketplace/get-user-details',
            type: 'GET',
            success: function(result) {
                if (typeof callback == 'function') {
                    callback(result);
                }

                // empty dispatch only
                return dispatch({
                    type: ''
                });
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

function getMerchantItems(callback) {
    return function(dispatch, getState) {
        const merchant = getState().merchantReducer;

        $.ajax({
            url: '/sub-marketplace/get-merchant-items',
            type: 'GET',
            data: {
                merchantUserId: merchant.user ? merchant.user.ID : false
            },
            success: function(result) {
                if (typeof callback == 'function') {
                    callback(result);
                }

                // empty dispatch only
                return dispatch({
                    type: ''
                });
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

function getMerchantFavorites(callback) {
    return function(dispatch, getState) {
        const merchant = getState().merchantReducer;

        $.ajax({
            url: '/sub-marketplace/get-merchant-favorites',
            type: 'GET',
            data: {
                merchantUserId: merchant.user ? merchant.user.ID : false
            },
            success: function(result) {
                if (typeof callback == 'function') {
                    callback(result);
                }

                // empty dispatch only
                return dispatch({
                    type: ''
                });
            },
            error: function(jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

export { getUserDetails, getMerchantItems, getMerchantFavorites };

export default {
    getUserDetails: getUserDetails,
    getMerchantItems: getMerchantItems,
    getMerchantFavorites: getMerchantFavorites
};
